import * as React             from 'react';
import * as cx                from 'classnames';
import { StatelessComponent } from 'react';

interface Props {
    message: string;
    className?: string;
    onClickAction?: (event) => void;
    error?: any;
}

const ErrorMessage: StatelessComponent<Props> = (props) => (
    <div className={cx('errorMessage', { 'errorMessage--box': props.error }, props.className)} onClick={props.onClickAction}>
        {props.message || (props.error && props.error.message)}
    </div>
);

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.tsx